import { render, staticRenderFns } from "./QuotesForm.vue?vue&type=template&id=544059c6&scoped=true&"
import script from "./QuotesForm.vue?vue&type=script&lang=js&"
export * from "./QuotesForm.vue?vue&type=script&lang=js&"
import style0 from "./QuotesForm.vue?vue&type=style&index=0&id=544059c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544059c6",
  null
  
)

export default component.exports